import { render, staticRenderFns } from "./LectureListItemTables.vue?vue&type=template&id=0d100177&"
import script from "./LectureListItemTables.vue?vue&type=script&lang=ts&"
export * from "./LectureListItemTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports